export interface ValidateDirectDebitPayload {
  accountNumber?: string;
  branchCode?: string;
  iban?: string;
}

export interface ValidateDirectDebitResponse {
  result: {
    isValid: boolean;
  };
  status: string;
}
